export const listingConfigDrawer = {
  close: `Schließen`,
  componentUnavailable: `Komponente nicht verfügbar.`,
};
